import client from '../client';
import interceptors from '../interceptors';
const aiVisibility = interceptors.get('aiVisibility');

client.interceptors.response.use(aiVisibility.s, aiVisibility.e);

const resource = '/ai-visibility';

export default {
  getDomainsList: async (params) => await client.get(`${resource}/domains`, { params }),
  addDomain: async (payload) => await client.post(`${resource}/domains`, payload),
  getDomain: async (id) => await client.get(`${resource}/domains/${id}`),
  deleteDomain: async (id) => await client.delete(`${resource}/domains/${id}`),
};
